module.exports = __webpack_public_path__ + "img/logo.2189d5cd.png";